module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/responsive-table/responsive-table.component.html
// module id = ./src/app/modules/common-module/components/responsive-table/responsive-table.component.html
// module chunks = 9